import { useEffect, useState } from "react";

/** True inside the Android app, which is a shell around this same website. */
export const inAndroidApp = /MangoMoonsApp\//.test(navigator.userAgent);
/** True in a browser on an Android phone or tablet, where the app can be downloaded. */
export const canGetAndroidApp = /Android/.test(navigator.userAgent) && !inAndroidApp && location.protocol === "https:";

export type InstallEvent = Event & { prompt(): Promise<unknown> };
export const installOffer: { event: InstallEvent | null } = { event: null };

/** A function that installs the web app on this phone or computer, or null when the browser is not offering it. */
export function useInstall(): (() => void) | null {
  const [event, setEvent] = useState(installOffer.event);
  useEffect(() => {
    const update = () => setEvent(installOffer.event);
    addEventListener("mm-install-offer", update);
    return () => removeEventListener("mm-install-offer", update);
  }, []);
  return event ? () => { void event.prompt(); installOffer.event = null; setEvent(null); } : null;
}
